export default __webpack_public_path__ + "static/media/O-058.91eb5a51.png";